import { render, staticRenderFns } from "./ciam-login.vue?vue&type=template&id=67697b2f&"
import script from "./ciam-login.vue?vue&type=script&lang=js&"
export * from "./ciam-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports